module.exports = __webpack_public_path__ + "img/promo_neowalls.eaa41a43.png";